import React, {FC} from 'react'
import classnames from 'classnames'
import {Row, Col} from 'antd'
import Table from '@/components/Table'
import Progress from '@/components/Progress'


import StylesType from '@/types/StylesType'
import {SelectIndexType, fileTypes, fileHistoryTypes, FileUploadingType} from "@/stores/base/UploadStore";

import './style/FileOpearTable.less'

export interface FileOpearTableTypes{
  selectIndex: SelectIndexType;
  fileList: (fileTypes)[];
  fileUploading: FileUploadingType[];
  fileHistoryList: fileHistoryTypes[];
  getDeleteId?:(id: number) => void
}

type FileOpearTableProps = StylesType & FileOpearTableTypes
const FileOpearTables: FC<FileOpearTableProps> = props => {
  const {prefixCls='gc_', className, selectIndex, fileList, fileUploading, fileHistoryList, getDeleteId} = props
  return (
    <div className={classnames(prefixCls+'file_opear_tables', className)}>
      {
        selectIndex === 1 && <AllFileTable dataSource={fileList} getDeleteId={getDeleteId}/>
      }
      {
        selectIndex === 2 && <UploadingTable dataSource={fileUploading}/>
      }
      {
        selectIndex === 3 && <UploadedTable dataSource={fileHistoryList}/>
      }
    </div>
  )
}

export default FileOpearTables
// 全部文件
interface AllFileTableTypes {
  dataSource: fileTypes[],
  getDeleteId?:(id: number) => void
}
type AllFileTableProps = StylesType & AllFileTableTypes

export const AllFileTable: FC<AllFileTableProps> = props => {
  const {prefixCls='gc_', className, dataSource, getDeleteId} = props

  const columns = [
    {title: '游戏名称', width: '145px', dataIndex: 'app_name', ellipsis: true,},
    {title: '文件名称', width: '177px', dataIndex: 'file_name', ellipsis: true,},
    {title: '包名称', width: '201px', dataIndex: 'bundle_id', ellipsis: true,},
    {title: '版本号', width: '82px', dataIndex: 'version_name', ellipsis: true,},
    {title: '文件大小', width: '100px', dataIndex: 'app_size', ellipsis: true,},
    {title: '操作', dataIndex: 'id',render:(id: number) => {
        return <span className={classnames('deleteOpear')} onClick={() => getDeleteId && getDeleteId(id)}>删除</span>
      }},
  ]

  return(
    <div className={classnames(prefixCls+'all_file_table', className)}>
      <Table columns={columns} dataSource={dataSource} rowKey='id' scroll={{y:459}} pagination={false}/>
    </div>
  )
}
// 正在上传
interface UploadingTableleTypes {
  dataSource: FileUploadingType[]
}
type UploadingTableleProps = StylesType & UploadingTableleTypes
export const UploadingTable: FC<UploadingTableleProps> = props => {
  const {prefixCls='gc_', className, dataSource} = props
  const columns = [
    {title: '文件名', width: '408px', dataIndex: 'fileName', ellipsis: true,},
    {title: '上传进度',  dataIndex: 'percent', render:(text: any) => {
        return (
          <Row type='flex' gutter={[10, 0]}>
            <Col>
              <Progress percent={text} showInfo={false} className={classnames('upload_file_progress')} strokeColor='#3796FF' strokeWidth={6}></Progress>
            </Col>
            <Col>
              <span>{text}%</span>
            </Col>
          </Row>
        )
      }},
  ]
  return(
    <div className={classnames(prefixCls+'uploading_table', className)}>
      <Table columns={columns} dataSource={dataSource}  rowKey="id" scroll={{y:459}} pagination={false}/>
    </div>
  )
}
// 上传记录
interface UploadedTableleTypes {
  dataSource: fileHistoryTypes[]
}
type UploadedTableleProps = StylesType & UploadedTableleTypes
export const UploadedTable: FC<UploadedTableleProps> = props => {
  const {prefixCls='gc_', className, dataSource} = props

  const columns = [
    {title: '文件名称', width: '600px', dataIndex: 'file_name', ellipsis: true,},
    {title: '上传进度', dataIndex: 'status', ellipsis: true,render: (text: any)=>{
      switch (text) {
        case -5:
          return <span className={classnames('upload_process')}>处理超时</span>
        case -4:
          return <span className={classnames('upload_process')}>系统错误</span>
        case -3:
          return <span className={classnames('upload_process')}>解析失败</span>
        case -2:
          return <span className={classnames('upload_process')}>下载失败</span>
        case -1:
          return <span className={classnames('upload_process')}>上传失败</span>
        case 0:
          return <span className={classnames('upload_process')}>处理中</span>
        case 1:
          return <span className={classnames('upload_process')}>正在上传</span>
        case 2:
          return <span className={classnames('upload_process', 'c3796ff')}>解析成功</span>
        default:
          return <span>失败</span>
      }},
    }
  ]

  return(
    <div className={classnames(prefixCls+'uploaded_table', className)}>
      <Table columns={columns} dataSource={dataSource} rowKey='id' scroll={{y:459}} pagination={false}/>
    </div>
  )
}
